export default class JobsFilterService {
    constructor() {
        JobsFilterService.renamingFilterButton()
    }

    static renamingFilterButton() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const buttonSelector =
                '.block__job-offers-list__filters.open:has(.block__job-offers-list__selection .facetwp-selections ul) ~ .block__job-offers-list__bottom-bar a'
            if ($(buttonSelector).length > 0) {
                buttonSelector.text('Voir le(s) offre(s)')
            }
        }
    }
}
